import { useRef, useEffect } from 'react';
import gsap from 'gsap';

//* Style
import DetailedInfoStyle from './style';

//* Helpers
import { useActiveSection } from '@/helpers';

//* Components
import Container from '@/components/common/Container';
import Image from '@/components/common/Image';
import Text from '@/components/common/Text';

const DetailedInfo = ({ title, description, image }) => {
	//! Refs
	const sectionRef = useRef();
	const imageRef = useRef();
	const detailedInfoRef = useRef();

	//! Active section
	const activeSection = useActiveSection(sectionRef, 90);

	useEffect(() => {
		if (activeSection) {
			gsap.to([detailedInfoRef.current, imageRef.current], { y: 0, opacity: 1, stagger: 0.001 });
		}
	}, [activeSection]);

	return (
		<DetailedInfoStyle ref={sectionRef}>
			<Container
				section
				className={'detailed-info-container'}>
				<div
					ref={detailedInfoRef}
					className='detailed-info-content'>
					<Text
						tag={'h2'}
						text={title}
					/>
					<div dangerouslySetInnerHTML={{ __html: description }} />
				</div>
				<Image
					ref={imageRef}
					className={'detailed-image'}
					src={image.src}
					alt={image.alt}
				/>
			</Container>
		</DetailedInfoStyle>
	);
};

export default DetailedInfo;
